export const yoni_dictionary = {
  "mriga": {
    "id": "mriga",
    "emoji": "🦌",
    "image": "/yoni/mriga.jpg",
    "title-en": "Deer",
    "title-ru": "Олень",
    "title_sanskrit-en": "Mriga",
    "title_sanskrit-ru": "Мрига",
    "sanskrit": "मृग",
    "description-en": "Sensitive, cautious, elegant. Seeks softness, freedom, beauty. Easily frightened, requires emotional safety.",
    "description-ru": "Чуткий, осторожный, изящный. Ищет мягкость, свободу, красоту. Легко пугается, требует эмоциональной безопасности.",
    "matchWith": ["mriga",
      "nakul",
      "go",
      "ashwa"],
    "misMatchWith": ["simha",
      "sarpa"]
  },
  "nakul": {
    "id": "nakul",
    "emoji": "🦫",
    "image": "/yoni/nakul.jpg",
    "title-en": "Mongoose",
    "title-ru": "Мангуст",
    "title_sanskrit-en": "Nakul",
    "title_sanskrit-ru": "Накула",
    "sanskrit": "नकुल",
    "description-en": "Playful, quick, decisive. Instinctively catches lies.",
    "description-ru": "Игривый, проворный, быстрый в суждениях. Инстинктивно ловит фальшь.",
    "matchWith": ["mriga",
      "marjara",
      "shwan"],
    "misMatchWith": ["vyaghra",
      "mahisha"]
  },
  "ashwa": {
    "id": "ashwa",
    "emoji": "🐎",
    "image": "/yoni/ashwa.jpg",
    "title-en": "Horse",
    "title-ru": "Лошадь",
    "title_sanskrit-en": "Ashwa",
    "title_sanskrit-ru": "Ашва",
    "sanskrit": "अश्व",
    "description-en": "Free-spirited, vivid, loves movement and spontaneity. Often creative type.",
    "description-ru": "Свободолюбивый, живой, любит движение и спонтанность. Часто творческий тип.",
    "description": "Свободолюбивый, живой, любит движение и спонтанность. Часто творческий тип.",
    "matchWith": ["ashwa",
      "gaja",
      "mriga"],
    "misMatchWith": ["sarpa",
      "simha"]
  },
  "gaja": {
    "id": "gaja",
    "emoji": "🐘",
    "image": "/yoni/gaja.jpg",
    "title-en": "Elephant",
    "title-ru": "Слон",
    "title_sanskrit-en": "Gaja",
    "title_sanskrit-ru": "Гаджа",
    "sanskrit": "गज",
    "description-en": "Powerful, stable, noble. Requires respect, patient, but stubborn. Values attachment and peace.",
    "description-ru": "Мощный, стабильный, благородный. Требует уважения, терпелив, но упрям. Ценит привязанность и спокойствие.",
    "matchWith": ["gaja",
      "ashwa",
      "go"],
    "misMatchWith": ["sarpa",
      "marjara"]
  },
  "sarpa": {
    "id": "sarpa",
    "emoji": "🐍",
    "image": "/yoni/sarpa.jpg",
    "title-en": "Snake",
    "title-ru": "Змея",
    "title_sanskrit-en": "Sarpa",
    "title_sanskrit-ru": "Сарпа",
    "sanskrit": "सर्प",
    "description-en": "Intuitive, deeply feeling, mystical, but can be manipulative. Seeks control and deep connection.",
    "description-ru": "Интуитивный, тонко чувствующий, мистичный, но может быть манипулятивным. Ищет контроль и глубокую связь.",
    "matchWith": ["sarpa",
      "mesh"],
    "misMatchWith": ["mriga",
      "gaja",
      "ashwa"]
  },
  "simha": {
    "id": "simha",
    "emoji": "🦁",
    "image": "/yoni/simha.jpg",
    "title-en": "Lion",
    "title-ru": "Лев",
    "title_sanskrit-en": "Simha",
    "title_sanskrit-ru": "Симха",
    "sanskrit": "सिंह",
    "description-en": "Dominant, charismatic, seeks leadership. Can suppress more sensitive partners.",
    "description-ru": "Доминирующий, харизматичный, стремится к лидерству. Может подавлять более чувствительных партнёров.",
    "matchWith": ["simha",
      "vyaghra"],
    "misMatchWith": ["mriga",
      "marjara"]
  },
  "marjara": {
    "id": "marjara",
    "emoji": "🐈",
    "image": "/yoni/marjara.jpg",
    "title-en": "Cat",
    "title-ru": "Кошка",
    "title_sanskrit-en": "Marjara",
    "title_sanskrit-ru": "Маржара",
    "sanskrit": "मार्जार",
    "description-en": "Refined, independent, intuitive. Needs respect for personal space.",
    "description-ru": "Утончённая, независимая, интуитивная. Нуждается в уважении к личному пространству.",
    "matchWith": ["nakul",
      "marjara",
      "shwan"],
    "misMatchWith": ["gaja",
      "simha"]
  },
  "shwan": {
    "id": "shwan",
    "emoji": "🐕",
    "image": "/yoni/shwan.jpg",
    "title-en": "Dog",
    "title-ru": "Собака",
    "title_sanskrit-en": "Shwan",
    "title_sanskrit-ru": "Шаван",
    "sanskrit": "श्वान",
    "description-en": "Loyal, devoted, protective. Can be jealous. Good with those who value attachment.",
    "description-ru": "Лояльный, преданный, защитник. Может ревновать. Хорош с теми, кто ценит привязанность.",
    "matchWith": ["shwan",
      "vyaghra",
      "nakul"],
    "misMatchWith": ["go",
      "mahisha"]
  },
  "go": {
    "id": "go",
    "emoji": "🐄",
    "image": "/yoni/go.jpg",
    "title-en": "Cow",
    "title-ru": "Корова",
    "title_sanskrit-en": "Go",
    "title_sanskrit-ru": "Го",
    "sanskrit": "गो",
    "description-en": "Soft, caring, peaceful, family-oriented. Poor at handling conflict and manipulation.",
    "description-ru": "Мягкая, заботливая, спокойная, ориентирована на семью. Плохо переносит конфликты и манипуляции.",
    "matchWith": [
      "go",
      "mahisha",
      "mriga"
    ],
    "misMatchWith": [
      "sarpa",
      "simha"
    ]
  },
  "buffalo": {
    "id": "mahisha",
    "emoji": "🐃",
    "image": "/yoni/buffalo.jpg",
    "title-en": "Buffalo",
    "title-ru": "Буйвол",
    "title_sanskrit-en": "Mahisha",
    "title_sanskrit-ru": "Махиша",
    "sanskrit": "महिष",
    "description-en": "Powerful, stable, but inert. Slow to get started, but reliable. Emotionally closed off.",
    "description-ru": "Мощный, стабильный, но инертный. Тяжело включается, но надёжен. Эмоционально закрыт.",
    "matchWith": [
      "mahisha",
      "go",
      "mesh"
    ],
    "misMatchWith": [
      "shwan",
      "marjara"
    ]
  },
  "vyaghra": {
    "id": "vyaghra",
    "emoji": "🐅",
    "image": "/yoni/vyaghra.jpg",
    "title-en": "Tiger",
    "title-ru": "Тигр",
    "title_sanskrit-en": "Vyaghra",
    "title_sanskrit-ru": "Вьягра",
    "sanskrit": "व्याघ्र",
    "description-en": "Strong, hunting, unpredictable. Intense vital energy. Does not tolerate control.",
    "description-ru": "Сильный, охотничий, непредсказуемый. Сильная жизненная энергия. Не терпит контроля.",
    "matchWith": ["simha",
      "shwan"],
    "misMatchWith": ["nakul",
      "go"]
  },
  "mesh": {
    "id": "mesh",
    "emoji": "🐏",
    "image": "/yoni/ram.jpg",
    "title-en": "Ram",
    "title-ru": "Баран",
    "title_sanskrit-en": "Mesh",
    "title_sanskrit-ru": "Меша",
    "sanskrit": "मेष",
    "description-en": "Impulsive, assertive, forceful. Thrives in struggle and intensity.",
    "description-ru": "Импульсивный, напористый, решительный. Хорош в борьбе и сильных переживаниях.",
    "matchWith": ["mesh",
      "sarpa",
      "mahisha"],
    "misMatchWith": ["go",
      "marjara"]
  },
  "mushika": {
    "id": "mushika",
    "emoji": "🐀",
    "image": "/yoni/mushika.jpg",
    "title-en": "Rodent",
    "title-ru": "Грызун",
    "title_sanskrit-en": "Mushika",
    "title_sanskrit-ru": "Мушика",
    "sanskrit": "मूषक",
    "description-en": "Quick, adaptable, resourceful. Cautious in close relationships, values security.",
    "description-ru": "Быстрый, приспосабливающийся, изобретательный. Осторожен в близких отношениях, ценит безопасность.",
    "matchWith": ["mushika",
      "nakul"],
    "misMatchWith": ["marjara",
      "shwan"]
  },
  "vanara": {
    "id": "vanara",
    "emoji": "🐒",
    "image": "/yoni/vanara.jpg",
    "title-en": "Ape-being",
    "title-ru": "Ванара",
    "title_sanskrit-en": "Vanara",
    "title_sanskrit-ru": "Ванара (Обезьяноподобное существо)",
    "sanskrit": "वानर",
    "description-en": "Playful, curious, restless. Loves variety and intellectual stimulation.",
    "description-ru": "Игривый, любознательный, непоседливый. Любит разнообразие и интеллектуальную стимуляцию.",
    "matchWith": ["vanara",
      "mriga"],
    "misMatchWith": ["mesh",
      "simha"]
  },
  "aj": {
    "id": "aj",
    "emoji": "🐐",
    "title-en": "Goat",
    "title-ru": "Коза",
    "title_sanskrit-en": "Aj",
    "title_sanskrit-ru": "Адж",
    "sanskrit": "अज",
    "description-en": "Gentle, artistic, mood-sensitive. Seeks harmony and aesthetic connection.",
    "description-ru": "Мягкий, артистичный, чувствительный к настроению. Ищет гармонию и эстетическую связь.",
    "matchWith": ["aj",
      "go",
      "mriga"],
    "misMatchWith": ["vyaghra",
      "sarpa"]
  }
}


export const nakshatra_yoni_dictionary = {
  "ashwini": {
    "id": "ashwini",
    "order": 1,
    "title": "Ashwini",
    "sanskrit": "अश्विनी",
    "yoniId": "ashwa",
    "yoniSanskrit": "Ashwa",
    "yoniTitle": "Horse",
    "yoniEmoji": "🐎"
  },
  "bharani": {
    "id": "bharani",
    "order": 2,
    "title": "Bharani",
    "sanskrit": "भरणी",
    "yoniId": "gaja",
    "yoniSanskrit": "Gaja",
    "yoniTitle": "Elephant",
    "yoniEmoji": "🐘"
  },
  "krittika": {
    "id": "krittika",
    "order": 3,
    "title": "Krittika",
    "sanskrit": "कृत्तिका",
    "yoniId": "mesh",
    "yoniSanskrit": "Mesh",
    "yoniTitle": "Ram",
    "yoniEmoji": "🐏"
  },
  "rohini": {
    "id": "rohini",
    "order": 4,
    "title": "Rohini",
    "sanskrit": "रोहिणी",
    "yoniId": "sarpa",
    "yoniSanskrit": "Sarpa",
    "yoniTitle": "Snake",
    "yoniEmoji": "🐍",
  },
  "mrigashira": {
    "id": "mrigashira",
    "order": 5,
    "title": "Mrigashira",
    "sanskrit": "मृगशिरा",
    "yoniId": "sarpa",
    "yoniSanskrit": "Sarpa",
    "yoniTitle": "Snake",
    "yoniEmoji": "🐍",
  },
  "ardra": {
    "id": "ardra",
    "order": 6, "title": "Ardra",
    "sanskrit": "आर्द्रा",
    "yoniId": "shwan",
    "yoniSanskrit": "Shwan",
    "yoniTitle": "Dog",
    "yoniEmoji": "🐕"
  },
  "punarvasu": {
    "id": "punarvasu",
    "order": 7, "title": "Punarvasu",
    "sanskrit": "पुनर्वसु",
    "yoniId": "marjara",
    "yoniSanskrit": "Marjara",
    "yoniTitle": "Cat",
    "yoniEmoji": "🐈"
  },
  "pushya": {
    "id": "pushya",
    "order": 8, "title": "Pushya",
    "sanskrit": "पुष्य",
    "yoniId": "mesh",
    "yoniSanskrit": "Mesh",
    "yoniTitle": "Ram",
    "yoniEmoji": "🐏"
  },
  "ashlesha": {
    "id": "ashlesha",
    "order": 9,
    "title": "Ashlesha",
    "sanskrit": "आश्लेषा",
    "yoniId": "marjara",
    "yoniSanskrit": "Marjara",
    "yoniTitle": "Cat",
    "yoniEmoji": "🐈",
  },
  "magha": {
    "id": "magha",
    "order": 10, "title": "Magha",
    "sanskrit": "मघा",
    "yoniId": "mushika",
    "yoniSanskrit": "Mushika",
    "yoniTitle": "Rat",
    "yoniEmoji": "🐀"
  },
  "purva_phalguni": {
    "id": "purva_phalguni",
    "order": 11, "title": "Purva Phalguni",
    "sanskrit": "पूर्व फाल्गुनी",
    "yoniId": "mushika",
    "yoniSanskrit": "Mushika",
    "yoniTitle": "Rat",
    "yoniEmoji": "🐀"
  },
  "uttara_phalguni": {
    "id": "uttara_phalguni",
    "order": 12, "title": "Uttara Phalguni",
    "sanskrit": "उत्तर फाल्गुनी",
    "yoniId": "go",
    "yoniSanskrit": "Go",
    "yoniTitle": "Cow",
    "yoniEmoji": "🐄"
  },
  "hasta": {
    "id": "hasta",
    "order": 13, "title": "Hasta",
    "sanskrit": "हस्त",
    "yoniId": "buffalo",
    "yoniSanskrit": "Mahisha",
    "yoniTitle": "Buffalo",
    "yoniEmoji": "🐃"
  },
  "chitra": {
    "id": "chitra",
    "order": 14, "title": "Chitra",
    "sanskrit": "चित्रा",
    "yoniId": "vyaghra",
    "yoniSanskrit": "Vyaghra",
    "yoniTitle": "Tiger",
    "yoniEmoji": "🐅"
  },
  "swati": {
    "id": "swati",
    "order": 15, "title": "Swati",
    "sanskrit": "स्वाती",
    "yoniId": "buffalo",
    "yoniSanskrit": "Mahisha",
    "yoniTitle": "Buffalo",
    "yoniEmoji": "🐃"
  },
  "vishakha": {
    "id": "vishakha",
    "order": 16, "title": "Vishakha",
    "sanskrit": "विशाखा",
    "yoniId": "vyaghra",
    "yoniSanskrit": "Vyaghra",
    "yoniTitle": "Tiger",
    "yoniEmoji": "🐅"
  },
  "anuradha": {
    "id": "anuradha",
    "order": 17, "title": "Anuradha",
    "sanskrit": "अनुराधा",
    "yoniId": "mriga",
    "yoniSanskrit": "Mriga",
    "yoniTitle": "Deer",
    "yoniEmoji": "🦌"
  },
  "jyeshtha": {
    "id": "jyeshtha",
    "order": 18, "title": "Jyeshtha",
    "sanskrit": "ज्येष्ठा",
    "yoniId": "mriga",
    "yoniSanskrit": "Mriga",
    "yoniTitle": "Deer",
    "yoniEmoji": "🦌"
  },
  "mula": {
    "id": "mula",
    "order": 19, "title": "Mula",
    "sanskrit": "मूल",
    "yoniId": "shwan",
    "yoniSanskrit": "Shwan",
    "yoniTitle": "Dog",
    "yoniEmoji": "🐕"
  },
  "purva_ashadha": {
    "id": "purva_ashadha",
    "order": 20, "title": "Purva Ashadha",
    "sanskrit": "पूर्वाषाढा",
    "yoniId": "vanara",
    "yoniSanskrit": "Vanara",
    "yoniTitle": "Monkey",
    "yoniEmoji": "🐒"
  },
  "uttara_ashadha": {
    "id": "uttara_ashadha",
    "order": 21, "title": "Uttara Ashadha",
    "sanskrit": "उत्तराषाढा",
    "yoniId": "nakul",
    "yoniSanskrit": "Nakul",
    "yoniTitle": "Mongoose",
    "yoniEmoji": "🦫"
  },
  "shravana": {
    "id": "shravana",
    "order": 22, "title": "Shravana",
    "sanskrit": "श्रवण",
    "yoniId": "vanara",
    "yoniSanskrit": "Vanara",
    "yoniTitle": "Monkey",
    "yoniEmoji": "🐒"
  },
  "dhanishta": {
    "id": "dhanishta",
    "order": 23, "title": "Dhanishta",
    "sanskrit": "धनिष्ठा",
    "yoniId": "simha",
    "yoniSanskrit": "Simha",
    "yoniTitle": "Lion",
    "yoniEmoji": "🦁"
  },
  "shatabhisha": {
    "id": "shatabhisha",
    "order": 24, "title": "Shatabhisha",
    "sanskrit": "शतभिषा",
    "yoniId": "ashwa",
    "yoniSanskrit": "Ashwa",
    "yoniTitle": "Horse",
    "yoniEmoji": "🐎"
  },
  "purva_bhadrapada": {
    "id": "purva_bhadrapada",
    "order": 25, "title": "Purva Bhadrapada",
    "sanskrit": "पूर्व भाद्रपदा",
    "yoniId": "simha",
    "yoniSanskrit": "Simha",
    "yoniTitle": "Lion",
    "yoniEmoji": "🦁"
  },
  "uttara_bhadrapada": {
    "id": "uttara_bhadrapada",
    "order": 26, "title": "Uttara Bhadrapada",
    "sanskrit": "उत्तर भाद्रपदा",
    "yoniId": "go",
    "yoniSanskrit": "Go",
    "yoniTitle": "Cow",
    "yoniEmoji": "🐄"
  },
  "revati": {
    "id": "revati",
    "order": 27,
    "title": "Revati",
    "sanskrit": "रेवती",
    "yoniId": "gaja",
    "yoniSanskrit": "Gaja",
    "yoniTitle": "Elephant",
    "yoniEmoji": "🐘",
  },
  "abhijit": {
    "id": "abhijit",
    "title": "Abhijit",
    "sanskrit": "अभिजित्",
    "yoniId": "nakul",
    "yoniSanskrit": "Nakul",
    "yoniTitle": "Mongoose",
    "yoniEmoji": "🐾", // суррогат
  }
}

export const yoni_matching = {
  "source": "https://saravali.github.io/astrology/koota_yoni.html",
  "schema": {
    "rows": "brideYoniId",
    "cols": "groomYoniId",
    "scoreRange": "0..4",
    "note": "Scores are Bride (row) → Groom (column)"
  },
  "yoniIdLabels": {
    "ashwa": "Horse",
    "gaja": "Elephant",
    "mesh": "Sheep (Mesha)",
    "sarpa": "Serpent",
    "shwan": "Dog",
    "marjara": "Cat",
    "mushika": "Rat",
    "go": "Cow",
    "buffalo": "Buffalo (Mahisha)",
    "vyaghra": "Tiger",
    "mriga": "Deer (Hare)",
    "vanara": "Monkey",
    "nakul": "Mongoose",
    "simha": "Lion"
  },
  "orderIndex": {
    "ashwa": 0,
    "gaja": 1,
    "mesh": 2,
    "sarpa": 3,
    "shwan": 4,
    "marjara": 5,
    "mushika": 6,
    "go": 7,
    "buffalo": 8,
    "vyaghra": 9,
    "mriga": 10,
    "vanara": 11,
    "nakul": 12,
    "simha": 13
  },
  "matrix": {
    "ashwa": {
      "ashwa": 4, "gaja": 2, "mesh": 2, "sarpa": 3, "shwan": 2, "marjara": 2, "mushika": 2, "go": 1, "buffalo": 0, "vyaghra": 1, "mriga": 3, "vanara": 3, "nakul": 2, "simha": 1
    },
    "gaja": {
      "ashwa": 2, "gaja": 4, "mesh": 3, "sarpa": 3, "shwan": 2, "marjara": 2, "mushika": 2, "go": 2, "buffalo": 3, "vyaghra": 1, "mriga": 2, "vanara": 3, "nakul": 2, "simha": 0
    },
    "mesh": {
      "ashwa": 2, "gaja": 3, "mesh": 4, "sarpa": 2, "shwan": 1, "marjara": 2, "mushika": 1, "go": 3, "buffalo": 3, "vyaghra": 1, "mriga": 2, "vanara": 0, "nakul": 3, "simha": 1
    },
    "sarpa": {
      "ashwa": 3, "gaja": 3, "mesh": 2, "sarpa": 4, "shwan": 2, "marjara": 1, "mushika": 1, "go": 1, "buffalo": 1, "vyaghra": 2, "mriga": 2, "vanara": 2, "nakul": 0, "simha": 2
    },
    "shwan": {
      "ashwa": 2, "gaja": 2, "mesh": 1, "sarpa": 2, "shwan": 4, "marjara": 2, "mushika": 1, "go": 2, "buffalo": 2, "vyaghra": 1, "mriga": 0, "vanara": 2, "nakul": 1, "simha": 1
    },
    "marjara": {
      "ashwa": 2, "gaja": 2, "mesh": 2, "sarpa": 1, "shwan": 2, "marjara": 4, "mushika": 0, "go": 2, "buffalo": 2, "vyaghra": 1, "mriga": 3, "vanara": 3, "nakul": 2, "simha": 1
    },
    "mushika": {
      "ashwa": 2, "gaja": 2, "mesh": 1, "sarpa": 1, "shwan": 1, "marjara": 0, "mushika": 4, "go": 2, "buffalo": 2, "vyaghra": 2, "mriga": 2, "vanara": 2, "nakul": 1, "simha": 2
    },
    "go": {
      "ashwa": 1, "gaja": 2, "mesh": 3, "sarpa": 1, "shwan": 2, "marjara": 2, "mushika": 2, "go": 4, "buffalo": 3, "vyaghra": 0, "mriga": 3, "vanara": 2, "nakul": 2, "simha": 1
    },
    "buffalo": {
      "ashwa": 0, "gaja": 3, "mesh": 3, "sarpa": 1, "shwan": 2, "marjara": 2, "mushika": 2, "go": 3, "buffalo": 4, "vyaghra": 1, "mriga": 2, "vanara": 2, "nakul": 2, "simha": 1
    },
    "vyaghra": {
      "ashwa": 1, "gaja": 1, "mesh": 1, "sarpa": 2, "shwan": 1, "marjara": 1, "mushika": 2, "go": 0, "buffalo": 1, "vyaghra": 4, "mriga": 1, "vanara": 1, "nakul": 2, "simha": 1
    },
    "mriga": {
      "ashwa": 1, "gaja": 2, "mesh": 2, "sarpa": 2, "shwan": 0, "marjara": 3, "mushika": 2, "go": 3, "buffalo": 2, "vyaghra": 1, "mriga": 4, "vanara": 2, "nakul": 2, "simha": 1
    },
    "vanara": {
      "ashwa": 3, "gaja": 3, "mesh": 0, "sarpa": 2, "shwan": 2, "marjara": 3, "mushika": 2, "go": 2, "buffalo": 2, "vyaghra": 1, "mriga": 2, "vanara": 4, "nakul": 3, "simha": 2
    },
    "nakul": {
      "ashwa": 2, "gaja": 2, "mesh": 3, "sarpa": 0, "shwan": 1, "marjara": 2, "mushika": 1, "go": 2, "buffalo": 2, "vyaghra": 2, "mriga": 2, "vanara": 3, "nakul": 4, "simha": 2
    },
    "simha": {
      "ashwa": 1, "gaja": 0, "mesh": 1, "sarpa": 2, "shwan": 1, "marjara": 1, "mushika": 2, "go": 1, "buffalo": 2, "vyaghra": 1, "mriga": 1, "vanara": 2, "nakul": 2, "simha": 4
    }
  }
}



// Gana by Nakshatra: Deva (Divine), Manushya (Human), Rakshasa (Demonic)
export const GANA_BY_NAKSHATRA = {
  "Ashwini": "Deva",
  "Bharani": "Manushya",
  "Krittika": "Rakshasa",
  "Rohini": "Manushya",
  "Mrigashira": "Deva",
  "Ardra": "Manushya",
  "Punarvasu": "Deva",
  "Pushya": "Deva",
  "Ashlesha": "Rakshasa",
  "Magha": "Rakshasa",
  "Purva Phalguni": "Manushya",
  "Uttara Phalguni": "Manushya",
  "Hasta": "Deva",
  "Chitra": "Rakshasa",
  "Swati": "Deva",
  "Vishakha": "Rakshasa",
  "Anuradha": "Deva",
  "Jyeshtha": "Rakshasa",
  "Mula": "Rakshasa",
  "Purva Ashadha": "Manushya",
  "Uttara Ashadha": "Manushya",
  "Shravana": "Deva",
  "Dhanishta": "Rakshasa",
  "Shatabhisha": "Rakshasa",
  "Purva Bhadrapada": "Manushya",
  "Uttara Bhadrapada": "Manushya",
  "Revati": "Deva"
};

// Varna by Nakshatra: classic 4-step cycle (most common)
export const VARNA_BY_NAKSHATRA = {
  "Ashwini": "Kshatriya",
  "Bharani": "Shudra",
  "Krittika": "Brahmin",
  "Rohini": "Shudra",
  "Mrigashira": "Vaishya",
  "Ardra": "Shudra",
  "Punarvasu": "Kshatriya",
  "Pushya": "Brahmin",
  "Ashlesha": "Brahmin",
  "Magha": "Shudra",
  "Purva Phalguni": "Kshatriya",
  "Uttara Phalguni": "Brahmin",
  "Hasta": "Vaishya",
  "Chitra": "Kshatriya",
  "Swati": "Vaishya",
  "Vishakha": "Vaishya",
  "Anuradha": "Brahmin",
  "Jyeshtha": "Kshatriya",
  // "Mula": "Butcher (вне варн) или Shudra",
  "Mula": "Shudra",
  "Purva Ashadha": "Kshatriya",
  "Uttara Ashadha": "Brahmin",
  "Shravana": "Vaishya",
  "Dhanishta": "Shudra",
  "Shatabhisha": "Shudra",
  "Purva Bhadrapada": "Brahmin",
  "Uttara Bhadrapada": "Brahmin",
  "Revati": "Shudra"
};


export const VARNA_BY_MOON_SIGN_ELEMENT = {
  "brahmin": {
    "label": "Brahmin",
    "element": "water",
    "moonSigns": {
      "cancer": "Cancer",
      "scorpio": "Scorpio",
      "pisces": "Pisces"
    }
  },
  "kshatriya": {
    "label": "Kshatriya",
    "element": "fire",
    "moonSigns": {
      "aries": "Aries",
      "leo": "Leo",
      "sagittarius": "Sagittarius"
    }
  },
  "vaishya": {
    "label": "Vaishya",
    "element": "air",
    "moonSigns": {
      "gemini": "Gemini",
      "libra": "Libra",
      "aquarius": "Aquarius"
    }
  },
  "shudra": {
    "label": "Shudra",
    "element": "earth",
    "moonSigns": {
      "taurus": "Taurus",
      "virgo": "Virgo",
      "capricorn": "Capricorn"
    }
  }
}


// Nithya Yogas (27): combination of Sun + Moon longitudes.
// Each spans 13°20' (360/27). Ordered list (index 0..26).
export const NITHYA_YOGA_ORDER = [
  "vishkumbha", "priti", "ayushman", "saubhagya", "shobhana",
  "atiganda", "sukarman", "dhriti", "shula", "ganda",
  "vriddhi", "dhruva", "vyaghata", "harshana", "vajra",
  "siddhi", "vyatipata", "variyan", "parigha", "shiva",
  "siddha", "sadhya", "shubha", "shukla", "brahma",
  "indra", "vaidhriti"
];

// nature: "most_auspicious" | "favorable" | "less_favorable" | "inauspicious"
// keyword: short meaning of the yoga's name; goodfor: muhurta (electional) indications
export const nithya_yoga_dictionary = {
  "vishkumbha": {
    "id": "vishkumbha", "order": 1, "emoji": "🏺", "nature": "inauspicious",
    "ruler-en": "Saturn", "ruler-ru": "Сатурн",
    "keyword-en": "Supported", "keyword-ru": "Опора",
    "title-en": "Vishkumbha", "title-ru": "Вишкумбха",
    "goodfor-en": "Overcoming obstacles, competitive ventures, wealth, will to succeed.",
    "goodfor-ru": "Преодоление препятствий, соперничество, богатство, воля к победе.",
    "description-en": "Charismatic and family-oriented, drawn to spiritual and occult matters. Strong willpower helps overcome early obstacles.",
    "description-ru": "Харизматичный и семейный, тянется к духовному и оккультному. Сильная воля помогает преодолевать ранние препятствия."
  },
  "priti": {
    "id": "priti", "order": 2, "emoji": "💞", "nature": "less_favorable",
    "ruler-en": "Mercury", "ruler-ru": "Меркурий",
    "keyword-en": "Fondness", "keyword-ru": "Симпатия",
    "title-en": "Priti", "title-ru": "Прити",
    "goodfor-en": "Gaining popularity and situations that call for charisma and eloquence.",
    "goodfor-ru": "Популярность и ситуации, требующие обаяния и красноречия.",
    "description-en": "Eloquent, lively and sociable. Builds a wide circle of friends and finds success through charm and communication.",
    "description-ru": "Красноречивый, живой и общительный. Строит широкий круг друзей, достигает успеха через обаяние и общение."
  },
  "ayushman": {
    "id": "ayushman", "order": 3, "emoji": "🌿", "nature": "favorable",
    "ruler-en": "Ketu / Rahu", "ruler-ru": "Кету / Раху",
    "keyword-en": "Long-lived", "keyword-ru": "Долголетие",
    "title-en": "Ayushman", "title-ru": "Аюшман",
    "goodfor-en": "Health, longevity, success and wealth.",
    "goodfor-ru": "Здоровье, долголетие, успех и богатство.",
    "description-en": "Associated with good health and longevity. Strong diplomatic and policy-making skills.",
    "description-ru": "Связан с крепким здоровьем и долголетием. Сильные дипломатические и стратегические способности."
  },
  "saubhagya": {
    "id": "saubhagya", "order": 4, "emoji": "🍀", "nature": "favorable",
    "ruler-en": "Brahma", "ruler-ru": "Брахма",
    "keyword-en": "Good Fortune", "keyword-ru": "Удача",
    "title-en": "Saubhagya", "title-ru": "Саубхагья",
    "goodfor-en": "All actions; brings happiness and luck.",
    "goodfor-ru": "Любые дела; приносит счастье и удачу.",
    "description-en": "Fortunate and comfort-loving. Enjoys prosperity, ease and good relationships throughout life.",
    "description-ru": "Удачливый и любящий комфорт. Наслаждается достатком, лёгкостью и хорошими отношениями."
  },
  "shobhana": {
    "id": "shobhana", "order": 5, "emoji": "✨", "nature": "favorable",
    "ruler-en": "Sun", "ruler-ru": "Солнце",
    "keyword-en": "Splendor", "keyword-ru": "Великолепие",
    "title-en": "Shobhana", "title-ru": "Шобхана",
    "goodfor-en": "Matters of intellect, beauty, sensuality and earning through honorable means.",
    "goodfor-ru": "Дела ума, красота, чувственность и честный заработок.",
    "description-en": "Known for physical beauty, intelligence and a sensual appreciation for life.",
    "description-ru": "Отличается физической красотой, умом и чувственным отношением к жизни."
  },
  "atiganda": {
    "id": "atiganda", "order": 6, "emoji": "⚠️", "nature": "inauspicious",
    "ruler-en": "Moon", "ruler-ru": "Луна",
    "keyword-en": "Great Obstacle", "keyword-ru": "Большое препятствие",
    "title-en": "Atiganda", "title-ru": "Атиганда",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Faces obstacles and emotional turbulence, but develops resilience and a protective, caring nature.",
    "description-ru": "Сталкивается с препятствиями и эмоциональными бурями, но развивает стойкость и заботливую натуру."
  },
  "sukarman": {
    "id": "sukarman", "order": 7, "emoji": "🛠️", "nature": "favorable",
    "ruler-en": "Indra", "ruler-ru": "Индра",
    "keyword-en": "Good Actions", "keyword-ru": "Благие дела",
    "title-en": "Sukarman", "title-ru": "Сукарма",
    "goodfor-en": "Taking action, wealth, success, accomplishment, business and the arts.",
    "goodfor-ru": "Активные действия, богатство, успех, свершения, бизнес и искусства.",
    "description-en": "Hard-working and capable. Achieves through good deeds, skill and steady effort.",
    "description-ru": "Трудолюбивый и способный. Достигает успеха через добрые дела, мастерство и упорный труд."
  },
  "dhriti": {
    "id": "dhriti", "order": 8, "emoji": "🧘", "nature": "less_favorable",
    "ruler-en": "Water (Apas)", "ruler-ru": "Вода (Апас)",
    "keyword-en": "Determination", "keyword-ru": "Стойкость",
    "title-en": "Dhriti", "title-ru": "Дхрити",
    "goodfor-en": "When support, consistency, loyalty and patience are needed.",
    "goodfor-ru": "Когда нужны поддержка, постоянство, верность и терпение.",
    "description-en": "Patient, steadfast and content. Enjoys the good things in life with calm determination.",
    "description-ru": "Терпеливый, стойкий и довольный. Наслаждается благами жизни со спокойной решимостью."
  },
  "shula": {
    "id": "shula", "order": 9, "emoji": "🔱", "nature": "inauspicious",
    "ruler-en": "Serpent (Sarpa)", "ruler-ru": "Змей (Сарпа)",
    "keyword-en": "Spear, Pain", "keyword-ru": "Копьё, боль",
    "title-en": "Shula", "title-ru": "Шула",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Sharp and assertive, sometimes quarrelsome. Strong energy that needs a constructive outlet.",
    "description-ru": "Острый и напористый, порой конфликтный. Сильная энергия, требующая конструктивного русла."
  },
  "ganda": {
    "id": "ganda", "order": 10, "emoji": "🌫️", "nature": "inauspicious",
    "ruler-en": "Fire (Agni)", "ruler-ru": "Огонь (Агни)",
    "keyword-en": "Knot (Hindrance)", "keyword-ru": "Узел (помеха)",
    "title-en": "Ganda", "title-ru": "Ганда",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Faces hurdles and sensitivities early on, but gains depth and discernment over time.",
    "description-ru": "Рано сталкивается с трудностями и чувствительностью, но со временем обретает глубину и проницательность."
  },
  "vriddhi": {
    "id": "vriddhi", "order": 11, "emoji": "📈", "nature": "favorable",
    "ruler-en": "Sun", "ruler-ru": "Солнце",
    "keyword-en": "Growth", "keyword-ru": "Рост",
    "title-en": "Vriddhi", "title-ru": "Вриддхи",
    "goodfor-en": "Growth, expansion, wisdom, speech, wealth, business and trade.",
    "goodfor-ru": "Рост, расширение, мудрость, речь, богатство, бизнес и торговля.",
    "description-en": "Growth-oriented; circumstances improve with age. Wise, adaptable and increasingly prosperous.",
    "description-ru": "Ориентирован на рост; обстоятельства улучшаются с возрастом. Мудрый, гибкий, растущее благополучие."
  },
  "dhruva": {
    "id": "dhruva", "order": 12, "emoji": "🪨", "nature": "favorable",
    "ruler-en": "Earth (Bhumi)", "ruler-ru": "Земля (Бхуми)",
    "keyword-en": "Eternal, Stable", "keyword-ru": "Постоянство",
    "title-en": "Dhruva", "title-ru": "Дхрува",
    "goodfor-en": "Wealth, learning, and when stability, constancy and longevity are required.",
    "goodfor-ru": "Богатство, учёба, а также когда нужны стабильность, постоянство и долговечность.",
    "description-en": "Stable, reliable and determined. Steady as a rock, dependable and grounded.",
    "description-ru": "Стабильный, надёжный и целеустремлённый. Твёрд как скала, постоянен и основателен."
  },
  "vyaghata": {
    "id": "vyaghata", "order": 13, "emoji": "🌪️", "nature": "inauspicious",
    "ruler-en": "Venus", "ruler-ru": "Венера",
    "keyword-en": "Blow, Defeat", "keyword-ru": "Удар, поражение",
    "title-en": "Vyaghata", "title-ru": "Вьягхата",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "May indicate struggles early in life, but blesses the native with cleverness and resilience.",
    "description-ru": "Может указывать на трудности в начале жизни, но наделяет сообразительностью и стойкостью."
  },
  "harshana": {
    "id": "harshana", "order": 14, "emoji": "😊", "nature": "favorable",
    "ruler-en": "Bhaga", "ruler-ru": "Бхага",
    "keyword-en": "Joyous", "keyword-ru": "Радость",
    "title-en": "Harshana", "title-ru": "Харшана",
    "goodfor-en": "Fame, popularity, wisdom and joy.",
    "goodfor-ru": "Слава, популярность, мудрость и радость.",
    "description-en": "Joyful, learned and enthusiastic. Spreads happiness and values knowledge.",
    "description-ru": "Радостный, образованный и воодушевлённый. Несёт радость и ценит знания."
  },
  "vajra": {
    "id": "vajra", "order": 15, "emoji": "💎", "nature": "inauspicious",
    "ruler-en": "Varuna", "ruler-ru": "Варуна",
    "keyword-en": "Diamond, Thunderbolt", "keyword-ru": "Алмаз, молния",
    "title-en": "Vajra", "title-ru": "Ваджра",
    "goodfor-en": "Power, strength, bravery, energy and motivation.",
    "goodfor-ru": "Сила, мощь, храбрость, энергия и мотивация.",
    "description-en": "Tough and unbreakable like a diamond. Goes through extremes but is hard to defeat.",
    "description-ru": "Твёрдый и несокрушимый, как алмаз. Проходит через крайности, но его трудно сломить."
  },
  "siddhi": {
    "id": "siddhi", "order": 16, "emoji": "🎯", "nature": "favorable",
    "ruler-en": "Ganesha", "ruler-ru": "Ганеша",
    "keyword-en": "Success", "keyword-ru": "Успех",
    "title-en": "Siddhi", "title-ru": "Сиддхи",
    "goodfor-en": "Success, fulfillment, protection and achievement; especially spiritual knowledge and sacred texts.",
    "goodfor-ru": "Успех, исполнение, защита и достижения; особенно духовное знание и священные тексты.",
    "description-en": "Accomplished and successful. Things tend to work out; supportive of others and goals.",
    "description-ru": "Успешный и достигающий целей. Дела складываются удачно; поддерживает других и свои стремления."
  },
  "vyatipata": {
    "id": "vyatipata", "order": 17, "emoji": "🌩️", "nature": "inauspicious",
    "ruler-en": "Rudra", "ruler-ru": "Рудра",
    "keyword-en": "Calamity", "keyword-ru": "Бедствие",
    "title-en": "Vyatipata", "title-ru": "Вьятипата",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Faces sudden ups and downs. Intense and transformative; learns through unexpected change.",
    "description-ru": "Сталкивается с резкими взлётами и падениями. Интенсивный и трансформирующий; учится через перемены."
  },
  "variyan": {
    "id": "variyan", "order": 18, "emoji": "🌊", "nature": "less_favorable",
    "ruler-en": "Kubera", "ruler-ru": "Кубера",
    "keyword-en": "Comfort", "keyword-ru": "Комфорт",
    "title-en": "Variyan", "title-ru": "Варияна",
    "goodfor-en": "Ambitious enterprises.",
    "goodfor-ru": "Амбициозные начинания.",
    "description-en": "Comfort-loving and easygoing. Enjoys pleasures, luxury and a relaxed pace of life.",
    "description-ru": "Любящий комфорт и непринуждённый. Наслаждается удовольствиями, роскошью и спокойным ритмом жизни."
  },
  "parigha": {
    "id": "parigha", "order": 19, "emoji": "🚧", "nature": "inauspicious",
    "ruler-en": "Vishwakarma", "ruler-ru": "Вишвакарма",
    "keyword-en": "Iron Bar, Barrier", "keyword-ru": "Засов, преграда",
    "title-en": "Parigha", "title-ru": "Паригха",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Meets obstruction and resistance, but persistence breaks through every barrier.",
    "description-ru": "Встречает препятствия и сопротивление, но настойчивость пробивает любой барьер."
  },
  "shiva": {
    "id": "shiva", "order": 20, "emoji": "🕉️", "nature": "favorable",
    "ruler-en": "Jupiter", "ruler-ru": "Юпитер",
    "keyword-en": "Auspicious, Bliss", "keyword-ru": "Благо, блаженство",
    "title-en": "Shiva", "title-ru": "Шива",
    "goodfor-en": "Success, respect, honor, intelligence, peace, bliss, love; especially Jyotish, yoga, mantras and control of the senses.",
    "goodfor-ru": "Успех, уважение, честь, ум, мир, блаженство, любовь; особенно джьотиш, йога, мантры и контроль чувств.",
    "description-en": "Highly spiritual, pious and dedicated to learning and helping others.",
    "description-ru": "Глубоко духовный, благочестивый, преданный учению и помощи другим."
  },
  "siddha": {
    "id": "siddha", "order": 21, "emoji": "🔥", "nature": "most_auspicious",
    "ruler-en": "Mars", "ruler-ru": "Марс",
    "keyword-en": "Accomplished, Proven", "keyword-ru": "Свершённый",
    "title-en": "Siddha", "title-ru": "Сиддха",
    "goodfor-en": "Business and any venture requiring virtue, adeptness and multiple skills.",
    "goodfor-ru": "Бизнес и любые дела, требующие добродетели, мастерства и разносторонних навыков.",
    "description-en": "Accomplished and skilled in arts or sciences, with deep focus on spiritual and personal growth.",
    "description-ru": "Достигший и искусный в искусствах или науках, с глубоким фокусом на духовном и личностном росте."
  },
  "sadhya": {
    "id": "sadhya", "order": 22, "emoji": "🤝", "nature": "favorable",
    "ruler-en": "Savitri", "ruler-ru": "Савитри",
    "keyword-en": "Achievable, Righteous", "keyword-ru": "Достижимость",
    "title-en": "Sadhya", "title-ru": "Садхья",
    "goodfor-en": "Accomplishing goals; especially where truth, purity and virtue are needed.",
    "goodfor-ru": "Достижение целей; особенно там, где нужны истина, чистота и добродетель.",
    "description-en": "Well-mannered and accomplished. Achieves goals through cooperation and refined behaviour.",
    "description-ru": "Воспитанный и достигающий. Добивается целей через сотрудничество и утончённое поведение."
  },
  "shubha": {
    "id": "shubha", "order": 23, "emoji": "🌟", "nature": "favorable",
    "ruler-en": "Lakshmi", "ruler-ru": "Лакшми",
    "keyword-en": "Auspicious, Radiant", "keyword-ru": "Благо, сияние",
    "title-en": "Shubha", "title-ru": "Шубха",
    "goodfor-en": "Wealth, success, happiness, beauty and grace.",
    "goodfor-ru": "Богатство, успех, счастье, красота и изящество.",
    "description-en": "Auspicious and attractive. Brings good fortune, charm and a pleasant presence.",
    "description-ru": "Благоприятный и привлекательный. Несёт удачу, обаяние и приятное присутствие."
  },
  "shukla": {
    "id": "shukla", "order": 24, "emoji": "🌕", "nature": "favorable",
    "ruler-en": "Parvati", "ruler-ru": "Парвати",
    "keyword-en": "Pure, Bright", "keyword-ru": "Чистота, свет",
    "title-en": "Shukla", "title-ru": "Шукла",
    "goodfor-en": "Intelligence, power of speech, wealth, success and the arts.",
    "goodfor-ru": "Интеллект, сила речи, богатство, успех и искусства.",
    "description-en": "Bright and creative, with an artistic and somewhat changeable temperament.",
    "description-ru": "Светлый и творческий, с артистичным и несколько переменчивым темпераментом."
  },
  "brahma": {
    "id": "brahma", "order": 25, "emoji": "📜", "nature": "most_auspicious",
    "ruler-en": "Brahma", "ruler-ru": "Брахма",
    "keyword-en": "Eternal, Wise", "keyword-ru": "Мудрость",
    "title-en": "Brahma", "title-ru": "Брахма",
    "goodfor-en": "Wisdom, honor, good judgment, resoluteness, secret wealth, and creative, spiritual or scholarly ventures.",
    "goodfor-ru": "Мудрость, честь, здравое суждение, решимость, скрытое богатство, творческие, духовные и научные дела.",
    "description-en": "Wise, trustworthy and visionary. A natural creator, planner and leader.",
    "description-ru": "Мудрый, надёжный и дальновидный. Прирождённый созидатель, стратег и лидер."
  },
  "indra": {
    "id": "indra", "order": 26, "emoji": "👑", "nature": "most_auspicious",
    "ruler-en": "Indra", "ruler-ru": "Индра",
    "keyword-en": "Chief, Best", "keyword-ru": "Вождь, лучший",
    "title-en": "Indra", "title-ru": "Индра",
    "goodfor-en": "Wealth, honor, power, prestige, popularity, and ventures involving intellect and beneficence.",
    "goodfor-ru": "Богатство, честь, власть, престиж, популярность и дела, связанные с интеллектом и благодеянием.",
    "description-en": "Influential and prosperous, with leadership ability and a taste for knowledge and status.",
    "description-ru": "Влиятельный и преуспевающий, с лидерскими качествами и тягой к знаниям и статусу."
  },
  "vaidhriti": {
    "id": "vaidhriti", "order": 27, "emoji": "🪢", "nature": "inauspicious",
    "ruler-en": "Diti", "ruler-ru": "Дити",
    "keyword-en": "Division, Malignant", "keyword-ru": "Разделение",
    "title-en": "Vaidhriti", "title-ru": "Вайдхрити",
    "goodfor-en": "",
    "goodfor-ru": "",
    "description-en": "Strong but restless energy that pulls in opposing directions; benefits from focus and discipline.",
    "description-ru": "Сильная, но беспокойная энергия, тянущая в разные стороны; помогает фокус и дисциплина."
  }
};

// Normalize minor variants (optional, but helps with APIs)
export const NAKSHATRA_ALIASES = {
  "Satabhisha": "Shatabhisha",
  "Shatabhishaj": "Shatabhisha",
  "Poorva Phalguni": "Purva Phalguni",
  "Uttara Phalguni ": "Uttara Phalguni",
  "Poorva Ashadha": "Purva Ashadha",
  "Uttara Ashadha ": "Uttara Ashadha",
  "Poorva Bhadrapada": "Purva Bhadrapada",
  "Uttara Bhadrapada ": "Uttara Bhadrapada",
  "Jyeshta": "Jyeshtha",
  "Jyestha": "Jyeshtha"
};
